import { FormCard } from '@purchase/supplier';
import { FC } from 'react';
import React from 'react';
import { IndustryExperience } from '../IndustryExperience';
import { ResourceCapabilities } from '../ResourceCapabilities';
import { TechnicalCapabilities } from '../TechnicalCapabilities';
import { TeamProfessional } from '../TeamProfessional';

// 合作案例和经验
const CollaborationCasesInfo: FC<{
  isOverseas?: boolean; // 是否为海外供应商/个人
  isCompany?: boolean; // 是否为企业
  isSupplierEnd?: boolean; // 是否为供应商端查看
  formDetail?: any;
  vendorId: string;
}> = ({ isOverseas, isCompany, isSupplierEnd, formDetail, vendorId }) => {
  return (
    <FormCard title="能力评估">
      <ResourceCapabilities formDetail={formDetail} />
      <TechnicalCapabilities formDetail={formDetail} />
      <TeamProfessional formDetail={formDetail} />
    </FormCard>
  );
};

export default CollaborationCasesInfo;
